import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { i18n } from 'config/locales';
import './KickbackFailureWarning.scss';
import { getSectionKeys } from '@redux/modules/section/selectors';
import { Modal } from '../../Modal';
import SvgComponent from '../SvgComponent';
import Logout from 'components/Navigation/Logout';

export class KickbackFailureWarning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: true,
    };

    // create a ref to store the button DOM element
    this.continueButton = React.createRef();
  }

  componentDidMount() {
    if (this.continueButton.current) {
      this.continueButton.current.focus();
    }
  };

  onClick = () => {
    this.setState({ show: false, });
    this.props.onKickbackWarningDismiss();
  };

  render() {
    return (
      <Modal className="kickback-warning-modal"
        show={this.state.show}
      >
        <div className="kickback-content">
          <div className="triangle-exclamation">
            <SvgComponent src="/img/triangle-exclamation.svg" />
          </div>
          <h2>{i18n.t('application.kickbackWarning.title')}</h2>
          <p aria-hidden>{i18n.t('application.kickbackWarning.message')}</p>

          <p aria-hidden>{i18n.t('application.kickbackWarning.assistance')}</p>
          <div className="buttons">
            <Logout />
            <button
              ref={this.continueButton}
              type="button"
              title={i18n.t('application.kickbackWarning.button')}
              aria-label={i18n.t('application.kickbackWarning.aria')}
              onClick={this.onClick}
              className="continue-button"
            >
              <span>{i18n.t('application.kickbackWarning.button')}</span>
              <div className="arrow-circle-right">
                <SvgComponent className="arrow-circle-right" src="/img/arrow-circle-right.svg" />
              </div >
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

KickbackFailureWarning.propTypes = {
  sectionKey: PropTypes.string,
  subsectionKey: PropTypes.string,
  dispatch: PropTypes.func,
  onKickbackWarningDismiss: PropTypes.func,
};

KickbackFailureWarning.defaultProps = {
  dispatch: () => { },
  onKickbackWarningDismiss: () => { },
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  ...getSectionKeys(state),
});

export default connect(mapStateToProps)(KickbackFailureWarning);
